import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { BrightnessContrastConfigModule, MaterialModule, ObjectFitConfigModule } from 'vhobjects-service';
import { NgZorroAntModule } from 'vhobjects-service';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule } from '@angular/forms';
import { VhLanguagePipeModule } from '../../../../../vh-language.pipe';
import { AtwNewFieldInputConfig } from './newField-input-config/newField-input-config.component';
import { AtwNewFieldSelectConfig } from './newField-select-config/newField-select-config.component';
import { AtwNewFieldTextConfig } from './newField-text-config/newField-text-config.component';
import { AtwCustomizeNewFieldConfig } from './customize-newField-config.component';
import { BordersConfigModule, HideShowConfigModule, LetterSpacingConfigModule, LineHeightConfigModule, PaddingConfigModule, ShadowConfigModule, SymbolConfigModule } from 'vhobjects-service';
import { VhStringPercentPipeModule } from '../../../../../vhstringpercent.pipe';
import { BordersRadiusConfigModule } from 'vhobjects-service';
import { ChooseAnimationsConfigModule } from 'vhobjects-service';
import { LinkPageModule } from 'vhobjects-service';
import { PositionOutConfigModule } from 'vhobjects-service';
import { RotateConfigModule } from 'vhobjects-service';
import { TextStyleConfigModule } from 'vhobjects-service';
import { WidthHeightConfigModule } from 'vhobjects-service';
import { TextFormatConfigModule } from 'vhobjects-service';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationsConfigModule } from 'vhobjects-service';
import { AtwNewFieldRadioButtonConfig } from './newField-radio-button-config/newField-radio-button-config.component';
import { AtwNewFieldImageConfig } from './newField-image-config/newField-image-config.component';

@NgModule({
  declarations: [
    AtwNewFieldInputConfig,
    AtwNewFieldSelectConfig,
    AtwNewFieldTextConfig,
    AtwNewFieldRadioButtonConfig,
    AtwCustomizeNewFieldConfig,
    AtwNewFieldImageConfig,
  ],
  imports: [
    CommonModule,
    ColorPickerModule,
    MaterialModule,
    NgZorroAntModule,
    ReactiveFormsModule,
    CKEditorModule,
    VhLanguagePipeModule,
    FormsModule,
    WidthHeightConfigModule,
    PositionOutConfigModule,
    LinkPageModule,
    ChooseAnimationsConfigModule,
    RotateConfigModule,
    TextStyleConfigModule,
    BordersConfigModule,
    BordersRadiusConfigModule,
    TextFormatConfigModule,
    TranslateModule,
    ShadowConfigModule,
    AnimationsConfigModule,
    HideShowConfigModule,
    SymbolConfigModule,
    VhStringPercentPipeModule,
    PaddingConfigModule,
    LetterSpacingConfigModule,
    LineHeightConfigModule,
    ObjectFitConfigModule,
    BrightnessContrastConfigModule
],
  exports: []
})
export class CustomizeNewFieldConfigModule { }